import { Link } from '@cian/link-component';
import * as React from 'react';
import { ICountrysideBuilderLandingPromoVillageData } from '../../types';
import { getUTMDataForLink } from '../../utils/getUTMDataForLink';
import { mergeUrlWithAdditionalQuery } from '../../utils/mergeUrlWithAdditionalQuery';
import { trackTrapLinkClick } from '../../utils/tracking/trackTrapLinkClick';
import { CircledBuilderVillage } from '../Icons';
import * as styles from './HeaderCountrysideBuilderPromo.css';

export interface IHeaderCountrysideBuilderPromoProps {
  data: ICountrysideBuilderLandingPromoVillageData;
  offerId: number;
}

export function HeaderCountrysideBuilderPromo({ data, offerId }: IHeaderCountrysideBuilderPromoProps) {
  if (!data.bannerLink || data.bannerType !== 'banner1') {
    return null;
  }

  const utm = getUTMDataForLink('banner1', offerId);

  return (
    <div className={styles['container']}>
      <div className={styles['icon_wrapper']}>
        <CircledBuilderVillage />
      </div>
      <p className={styles['description']}>Сколько стоит построить здесь дом?</p>
      <Link
        className={styles['link']}
        href={mergeUrlWithAdditionalQuery(data.bannerLink, utm)}
        target="_blank"
        rel="nofollow noopener"
        onClick={() => trackTrapLinkClick(offerId)}
      >
        Рассчитать
      </Link>
    </div>
  );
}
